import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import Theme from '/MuiTheme';

const useStyles = makeStyles((t) => ({
  root: {
    margin: '0 auto',
    maxWidth: '500px',
    padding: '16px 30px',
    [t.breakpoints.up('md')]: {
      border: '1px solid #104E75',
      borderRadius: '5px',
    },
    [t.breakpoints.down('sm')]: {
      padding: '16px 0px',
    },
  },
}));

interface FormContainerProps {
  children: React.ReactNode;
  elevation?: number;
}

const FormContainer: React.FC<FormContainerProps> = ({ children, elevation }) => {
  const classes = useStyles();

  return (
    <Paper className={classes.root} elevation={elevation && useMediaQuery(Theme.breakpoints.up('md')) ? elevation : 0}>
      {children}
    </Paper>
  );
};

export default FormContainer;
